/**
 * Transforms (parses) a JSON string to {@link Json} value.
 * @example
 * ```ts
 * type User = {
 *   name: string;
 * };
 *
 * const user = fromJSON<User>('{"name":"Carlos Marcos"}');
 * //=> { name: 'Carlos Marcos' }
 * ```
 * @param json - The JSON string.
 */
function fromJSON(json) {
    return JSON.parse(json);
}
export default fromJSON;
//# sourceMappingURL=fromJSON.js.map